import { render, staticRenderFns } from "./ActiveTenders.vue?vue&type=template&id=70288a8b&scoped=true"
import script from "./ActiveTenders.vue?vue&type=script&lang=js"
export * from "./ActiveTenders.vue?vue&type=script&lang=js"
import style0 from "./ActiveTenders.vue?vue&type=style&index=0&id=70288a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70288a8b",
  null
  
)

export default component.exports